import React from "react";
import { useAuth } from "@/context/AuthContext";
import { PageHeader, EmptyState } from "@/components/common";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { RecordsTab, DataExportTab } from "@/pages/RecordsAdmin";
import { FolderArchive, Archive, ShieldAlert } from "lucide-react";

const tabCls = "data-[state=active]:bg-brand-navy data-[state=active]:text-white text-slate-500 gap-1.5";

export default function Records() {
  const { user } = useAuth();
  const caps = user?.capabilities || [];
  const canRecords = caps.includes("records_management");
  const canExport = caps.includes("data_export");
  React.useEffect(() => { document.title = "Records | GovFlowState"; }, []);

  if (!canRecords && !canExport) {
    return (
      <div data-testid="records-page">
        <PageHeader title="Records" subtitle="Records governance and data export." />
        <EmptyState icon={ShieldAlert} title="No records access"
          description="You need the Records Management or Data Export capability. Please contact an administrator." />
      </div>
    );
  }

  return (
    <div data-testid="records-page">
      <PageHeader title="Records" subtitle="Govern official records — retention, holds and disposition — and export your data in common formats." />
      <Tabs defaultValue={canRecords ? "manage" : "export"}>
        <TabsList className="bg-white border border-brand-line">
          {canRecords && <TabsTrigger value="manage" data-testid="records-tab-manage" className={tabCls}><FolderArchive className="h-3.5 w-3.5" />Records Management</TabsTrigger>}
          {canExport && <TabsTrigger value="export" data-testid="records-tab-export" className={tabCls}><Archive className="h-3.5 w-3.5" />Data Export</TabsTrigger>}
        </TabsList>
        {canRecords && <TabsContent value="manage" className="mt-4"><RecordsTab /></TabsContent>}
        {canExport && <TabsContent value="export" className="mt-4"><DataExportTab /></TabsContent>}
      </Tabs>
    </div>
  );
}
